import { ReactComponentManifest } from "web/entrypoints/common/setup";
import { Feed } from "web/react/pages/feed/feed";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    Feed: withRedux(Feed),
};

export default components;
